module.exports = __webpack_public_path__ + "media/images/talent/voice-thum02-31361300d4bdb154a6d403aba2e66e27.png";